import { CardGrid } from 'foundations-components/transitional/components/CardGrid';
import CommentListRow from './CommentListRow';
import { jsx as _jsx } from "react/jsx-runtime";
function CommentList({
  onSaveComment,
  onDeleteComment,
  comments
}) {
  return /*#__PURE__*/_jsx(CardGrid, {
    columnSize: 300,
    gutterSize: 32,
    children: comments.map(comment => /*#__PURE__*/_jsx(CommentListRow, {
      content: comment,
      onSaveComment: () => onSaveComment(comment.commentId),
      onDeleteComment: () => onDeleteComment(comment)
    }, comment.commentId))
  });
}
export default CommentList;